// extracted by mini-css-extract-plugin
module.exports = {"inspector":"styles_inspector__3whEJ"};